import { axiosInstance } from 'src/config/axiosInstance';

class BookingsService {
  static async fetchBookingsSummary(companyId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(`/bookings/summary/${companyId}`);
        return response;
      } catch (error) {
        console.error('An error occurred:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
    return [];
  }

  static async deleteBooking(bookingId) {
    try {
      const response = await axiosInstance.post(`/bookings/delete/${bookingId}`);
      return response;
    } catch (error) {
      console.error('An error occurred:', error);
    }
  }

  static async fetchBookingsUser(userId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(`/bookings/user/${userId}`);
        return response;
      } catch (error) {
        console.error('An error occurred:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
    return [];
  }

  static async fetchBookingsList(companyId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(`/bookings/company/${companyId}`);
        return response;
      } catch (error) {
        console.error('An error occurred:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
    return [];
  }

  static async fetchWalletBalanceFromAPI(companyId, maxRetries, retryDelay) {
    if (!companyId) {
      console.error('companyId is not provided');
      return null; // O puedes lanzar un error aquí si prefieres manejarlo de esa manera
    }
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(`/wallet/balance/${companyId}`);
        return response;
      } catch (error) {
        console.error('An error occurred:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }

  static async fetchBookingDetails(bookingId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(`/bookings/${bookingId}`);
        return response;
      } catch (error) {
        console.error('Error fetching project details:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }
  static async createBooking(bookingData, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.post('/bookings/new', bookingData);
        return response;
      } catch (error) {
        console.error('Error creating new booking:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }
  static async confirmBooking(bookingData, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.post('/bookings/confirm', bookingData);
        return response;
      } catch (error) {
        console.error('Error creating new booking:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }

  static async createCustomerBookingIntent(projectId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(`/bookings/customerIntent/new/${projectId}`);
        return response;
      } catch (error) {
        console.error('Error creating customer booking intent:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }

  static async getBookingDetailsForPayment(bookingId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(
          `/bookings/getBookingDetailsForPayment/${bookingId}`
        );
        return response;
      } catch (error) {
        console.error('Error creating customer booking intent:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }
}

export default BookingsService;
